<template>
  <div>
    <b-alert
      show
      :variant="color"
    >
      <div class="alert-body">
        <feather-icon
          class="mr-25"
          :icon="icon"
        />
        <span class="ml-25">{{ text }}</span>
      </div>
    </b-alert>
  </div>
</template>

<script>
import { BAlert } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'TituloSecction',
  directives: {
    Ripple,
  },
  components: {
    BAlert,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: 'primary',
    },
  },
}
</script>

<style></style>
